import React from 'react';

export function renderErrors(fieldError){
    return fieldError?fieldError.map(error => { return <li>{error}</li> }):'';
}